import { TimeSyncService } from '@services/TimeSyncService';

import { useCountdownUntill } from '@libs/hooks/useCountdownUntill';

import { IGame } from '@features/game/types/game';

import { MatchCountdown } from './MatchCountdown';

export function MatchCountdownWidget({ game }: { game: IGame }) {
  const { seconds } = useCountdownUntill(
    TimeSyncService.instance.toClientTimestamp(game.startTimestampMs),
  );

  return <MatchCountdown seconds={seconds} />;
}
